


































































  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { RadioGroupOuiNon } from '@/commun/components/champ-formulaire/radio-group-oui-non';
  import { SelectAutocomplete } from '@/commun/components/champ-formulaire/select-autocomplete';
  import SelectAutocompleteItem from '@/commun/components/champ-formulaire/select-autocomplete/select-autocomplete-item';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import { StepperCredits } from '@/components/faculte/demandes/formulaires/champs/stepper-credits';
  import { SectionFormulaireCours } from '@/components/faculte/demandes/formulaires/creation-cours/section-formulaire-cours';
  import { SectionModeEnseignement } from '@/components/faculte/demandes/formulaires/creation-cours/section-information-mode-enseignement/sections-mode-enseignement';
  import ChargeTravail from '@/components/faculte/demandes/formulaires/creation-cours/section-information-mode-enseignement/sections-mode-enseignement/charge-travail/charge-travail.vue';
  import { AttributStage } from '@/domain/models/attribut-stage';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'ModeEnseignementStageFormulaire',
    components: {
      ChargeTravail,
      ChampFormulaire,
      RadioGroupOuiNon,
      SelectAutocomplete,
      StepperCredits,
      Tooltip,
    },
    mixins: [SectionFormulaireCours, SectionModeEnseignement],
    props: {
      radioReinitialisable: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      attributsStage: Object.values(AttributStage),
    }),
    computed: {
      attributsStageItems(): SelectAutocompleteItem[] {
        return (this.attributsStage as string[]).map(
          (attributStage: string) => ({
            texte: this.$i18n
              .t(
                `demande.formulaires.champs.attribut-de-stage.${attributStage}`
              )
              .toString(),
            valeur: attributStage,
          })
        );
      },
    },
  });
